import numeral from 'numeral';
import moment from 'moment';

const TICKET = 'Recibo';
const WARRANTY = 'Garantia';
const REMAINDER = 'Remanente';

const getBillsAmount = billList =>
  billList &&
  billList
    .map(bill => (bill.Categoria === TICKET ? bill.SALDO : 0))
    .reduce((current, previous) => current + previous, 0);

const getDownPayment = billList =>
  billList &&
  billList
    .map(bill => (bill.Categoria === WARRANTY ? bill.SALDO : 0))
    .reduce((current, previous) => current + previous, 0);

const getRemainderAmount = billList =>
  billList &&
  billList
    .map(bill => (bill.Categoria === REMAINDER ? bill.SALDO : 0))
    .reduce((current, previous) => current + previous, 0);

const mapAndFilter = array =>
  array
    .filter(element => element.amount !== 0)
    .map(element => ({ ...element, amount: numeral(element.amount).format('$ 0.[00]') }));

export const getAccountDebtConcepts = billList =>
  mapAndFilter([
    {
      concept: 'Facturas impagas',
      amount: getBillsAmount(billList) || 0
    },
    {
      concept: 'Depósito en garantía',
      amount: getDownPayment(billList) || 0
    },
    {
      concept: 'Cálculo consumo a la fecha',
      amount: getRemainderAmount(billList) || 0
    }
  ]);

export const getConceptsByAmount = (unpaidAmount, warrantyAmount, remainderAmount) =>
  mapAndFilter([
    {
      concept: 'Facturas impagas',
      amount: unpaidAmount || 0
    },
    {
      concept: 'Depósito en garantía',
      amount: warrantyAmount || 0
    },
    {
      concept: 'Cálculo consumo a la fecha',
      amount: remainderAmount || 0
    }
  ]);

export const getAccountDueConcepts = accountDueDebt => [
  {
    concept: 'Facturas impagas',
    amount: numeral(accountDueDebt || 0).format('$ 0.[00]')
  }
];

export const getProcedureHistory = history => {
  const procedureHistory =
    history &&
    history.ProcessActivity &&
    history.ProcessActivity.ProcessActivitiesHistories &&
    history.ProcessActivity.ProcessActivitiesHistories.map(state => ({
      date: moment(state.Created).format('L'),
      status: state.State && state.State.Name
    }));
  return [
    ...procedureHistory,
    {
      date: history && history.ProcessActivity && moment(history.ProcessActivity.Updated).format('L'),
      status:
        history &&
        history.ProcessActivity &&
        history.ProcessActivity.State &&
        history.ProcessActivity.State.Title
    }
  ];
};

export const getTotalAmount = (accountTotalDebt, accountDueDebt, format = true) => {
  const totalAmount =
    getBillsAmount(accountTotalDebt && accountTotalDebt.Recibos) +
    getDownPayment(accountTotalDebt && accountTotalDebt.Recibos) +
    getRemainderAmount(accountTotalDebt && accountTotalDebt.Recibos) +
    (accountDueDebt ? accountDueDebt.Deuda : 0);

  return format ? `$ ${totalAmount.toFixed(2)}` : totalAmount.toFixed(2);
};

export const getBillListTotalAmount = (billList, format = true) => {
  const totalAmount =
    billList && billList.map(bill => bill.SALDO || 0).reduce((current, previous) => current + previous, 0);
  return format ? numeral(totalAmount).format('$ 0.[00]') : totalAmount.toFixed(2);
};

export const getPayableBills = billList =>
  billList &&
  billList.length &&
  billList.map(bill => ({
    external_id: bill.ID_RECIBO,
    client_number: bill.NIS,
    amount: bill.SALDO
  }));
